// extracted by mini-css-extract-plugin
module.exports = {"headingRow":"TermsAndConditions_headingRow__d670G","headingSubTitle":"TermsAndConditions_headingSubTitle__biKOU","iframeContainer":"TermsAndConditions_iframeContainer__tqTa_"};